import React, { Component } from 'react';
import { Row, Col, Form } from 'antd';
import styled from 'styled-components';

import Button from 'components/Button/Button';
import Card from 'components/Card/Card';
import RenoCalculatorContent from './components/RenoCalculatorContent/RenoCalculatorContent';
import RenoCalculatorHeader from './components/RenoCalculatorHeader/RenoCalculatorHeader';
import RenoCalculatorFilterSection from './components/RenoCalculatorFilterSection/RenoCalculatorFilterSection';
import BackgroundImage from './images/bg.svg';

import {
  getItems,
  sections,
  ITEM_OWNED_AIRCOND,
  ITEM_OWNED_ELECTRIC_STOVE,
  ITEM_OWNED_KITCHEN_CABINET,
  ITEM_OWNED_WATER_HEATER
} from './data/costEstimation';

const ITEMS_OWNED_BY_UNIT = [
  { value: ITEM_OWNED_AIRCOND, label: 'Air-conditioner' },
  { value: ITEM_OWNED_WATER_HEATER, label: 'Water Heater' },
  { value: ITEM_OWNED_ELECTRIC_STOVE, label: 'Electric Stove' },
  { value: ITEM_OWNED_KITCHEN_CABINET, label: 'Kitchen Cabinet' }
];

const MainContainer = styled(Row)`
  background-image: url(${BackgroundImage});
  min-height: 100vh;
  background-size: cover;
`;

const ContentCard = styled(Card)`
  flex-direction: column;
  @media (min-width: 992px) {
    flex-direction: row;
  }
`;

const ContentContainer = styled.div`
  padding: 16px 8px;
  background-color: ${props => props.theme.color.white};
`;

const StyledButtonContainer = styled.div`
  margin: 32px 16px;
  display: block;
  @media (min-width: 992px) {
    display: none;
  }
`;

const StyledRow = styled.div`
  width: 100% !important;
`;
class RenoCalculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemsData: [],
      estimatedTotalCost: 0
    };
  }

  componentDidMount() {
    const defaultItems = getItems();
    this.restructureRenoItems(defaultItems);
  }

  handleOnBedroomChange = noOfBedrooms => {
    const { form } = this.props;
    const noOfBathrooms = form.getFieldValue('noOfBathrooms');
    const itemsOwnedByUnit = form.getFieldValue('itemsOwnedByUnit');
    const items = getItems(noOfBedrooms, noOfBathrooms, itemsOwnedByUnit);
    this.restructureRenoItems(items);
  };

  handleOnBathroomChange = noOfBathrooms => {
    const { form } = this.props;
    const noOfBedrooms = form.getFieldValue('noOfBedrooms');
    const itemsOwnedByUnit = form.getFieldValue('itemsOwnedByUnit');
    const items = getItems(noOfBedrooms, noOfBathrooms, itemsOwnedByUnit);
    this.restructureRenoItems(items);
  };

  handleOnItemsOwnedByUnitSelect = selections => {
    const { form } = this.props;
    const noOfBedrooms = form.getFieldValue('noOfBedrooms');
    const noOfBathrooms = form.getFieldValue('noOfBathrooms');
    const items = getItems(noOfBedrooms, noOfBathrooms, selections);
    this.restructureRenoItems(items);
  };

  handleOnIDServiceToggle = isToggled => {};

  restructureRenoItems = items => {
    let itemsData = [];
    for (let i = 0; i < sections.length; i++) {
      const filteredItems = items.filter(item => item.type === sections[i] && !item.isExcluded);
      itemsData.push(this.constructRenoItemsBySection(sections[i], filteredItems));
    }
    this.setState({
      itemsData,
      estimatedTotalCost: itemsData.reduce((total, currentItem) => total + currentItem.totalAmount, 0)
    });
  };

  constructRenoItemsBySection = (sectionHeader, filteredItems) => {
    const totalAmount = filteredItems.reduce((total, currentItem) => Math.round(total + currentItem.total), 0);
    return {
      header: sectionHeader,
      items: filteredItems,
      totalAmount
    };
  };

  render() {
    const { form } = this.props;
    const { itemsData, estimatedTotalCost } = this.state;
    return (
      <MainContainer type="flex" justify="center" align="middle">
        <Col span={24} lg={22} xxl={16}>
          <ContentCard>
            <Col span={24} lg={8}>
              <RenoCalculatorFilterSection
                form={form}
                itemsOwnedByUnitSelections={ITEMS_OWNED_BY_UNIT}
                onIDServiceToggle={this.handleOnIDServiceToggle}
                onBedroomChange={this.handleOnBedroomChange}
                onBathroomChange={this.handleOnBathroomChange}
                onItemsOwnedByUnitSelect={this.handleOnItemsOwnedByUnitSelect}
              />
            </Col>
            <Col span={24} lg={16}>
              <Row>
                <RenoCalculatorHeader estimatedTotalCost={estimatedTotalCost} />
              </Row>
              <ContentContainer>
                {itemsData.map(itemData => (
                  <RenoCalculatorContent key={itemData.header} header={itemData.header} data={itemData.items} totalAmount={itemData.totalAmount} />
                ))}
              </ContentContainer>
            </Col>
            <StyledButtonContainer>
              <StyledRow>
                <Row gutter={12}>
                  <Col span={12}>
                    <Button size="default" style={{ width: '100%' }} type="secondary" toUrl="/">
                      Home
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button size="default" style={{ width: '100%' }} type="primary" toUrl="/enquiry" prevUrl="/reno-calculator">
                      Enquire More
                    </Button>
                  </Col>
                </Row>
              </StyledRow>
            </StyledButtonContainer>
          </ContentCard>
        </Col>
      </MainContainer>
    );
  }
}

export default Form.create()(RenoCalculator);
